import * as actionTypes from './actionTypes';
import userService from '../../services/userService';

// Fetch Users
export const fetchUsers = (params = {}) => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_USERS_REQUEST });
  try {
    const response = await userService.getUsers(params);
    dispatch({
      type: actionTypes.FETCH_USERS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_USERS_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch users',
    });
  }
};

export const fetchUserStats = (params = {}) => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_USER_STATISTICS_REQUEST });
  try {
    const response = await userService.getUserStatistics(params);
    dispatch({
      type: actionTypes.FETCH_USER_STATISTICS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_USER_STATISTICS_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch user statistics',
    });
  }
};

// Fetch Single User
export const fetchUser = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_USER_REQUEST });
  try {
    const response = await userService.getUser(id);
    dispatch({
      type: actionTypes.FETCH_USER_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_USER_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch user',
    });
  }
};

// Create User
export const createUser = (userData) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE_USER_REQUEST });
  try {
    const response = await userService.createUser(userData);
    dispatch({
      type: actionTypes.CREATE_USER_SUCCESS,
      payload: response.data,
    });
    //dispatch(showAlert('User created successfully', 'success'));
    return response.data;
  } catch (error) {
    dispatch({
      type: actionTypes.CREATE_USER_FAILURE,
      payload: error.response?.data?.error || 'Failed to create user',
    });
    //dispatch(showAlert(error.response?.data?.error || 'Failed to create user', 'error'));
    throw error;
  }
};

// Update User
export const updateUser = (id, userData) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE_USER_REQUEST });
  try {
    const response = await userService.updateUser(id, userData);
    dispatch({
      type: actionTypes.UPDATE_USER_SUCCESS,
      payload: response.data,
    });
    //dispatch(showAlert('User updated successfully', 'success'));
    return response.data;
  } catch (error) {
    dispatch({
      type: actionTypes.UPDATE_USER_FAILURE,
      payload: error.response?.data?.error || 'Failed to update user',
    });
    //dispatch(showAlert(error.response?.data?.error || 'Failed to update user', 'error'));
    throw error;
  }
};

// Delete User
export const deleteUser = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE_USER_REQUEST });
  try {
    await userService.deleteUser(id);
    dispatch({
      type: actionTypes.DELETE_USER_SUCCESS,
      payload: id,
    });
    //dispatch(showAlert('User deleted successfully', 'success'));
  } catch (error) {
    dispatch({
      type: actionTypes.DELETE_USER_FAILURE,
      payload: error.response?.data?.error || 'Failed to delete user',
    });
    //dispatch(showAlert(error.response?.data?.error || 'Failed to delete user', 'error'));
    throw error;
  }
};

// Toggle User Status
export const toggleUserStatus = (id, isActive) => async (dispatch) => {
  dispatch({ type: actionTypes.TOGGLE_USER_STATUS_REQUEST });
  try {
    const response = await userService.toggleUserStatus(id, isActive);
    dispatch({
      type: actionTypes.TOGGLE_USER_STATUS_SUCCESS,
      payload: response.data,
    });
    //dispatch(showAlert(`User ${isActive ? 'activated' : 'deactivated'} successfully`, 'success'));
  } catch (error) {
    dispatch({
      type: actionTypes.TOGGLE_USER_STATUS_FAILURE,
      payload: error.response?.data?.error || 'Failed to toggle user status',
    });
    //dispatch(showAlert(error.response?.data?.error || 'Failed to toggle user status', 'error'));
  }
};

// Reset User Password
export const resetUserPassword = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.RESET_USER_PASSWORD_REQUEST });
  try {
    const response = await userService.resetUserPassword(id);
    dispatch({
      type: actionTypes.RESET_USER_PASSWORD_SUCCESS,
      payload: response.data,
    });
    //dispatch(showAlert('Password reset successfully', 'success'));
    return response.data;
  } catch (error) {
    dispatch({
      type: actionTypes.RESET_USER_PASSWORD_FAILURE,
      payload: error.response?.data?.error || 'Failed to reset password',
    });
    //dispatch(showAlert(error.response?.data?.error || 'Failed to reset password', 'error'));
    throw error;
  }
};

// Verify User
export const verifyUser = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.VERIFY_USER_REQUEST });
  try {
    const response = await userService.verifyUser(id);
    dispatch({
      type: actionTypes.VERIFY_USER_SUCCESS,
      payload: response.data,
    });
    //dispatch(showAlert('User verified successfully', 'success'));
  } catch (error) {
    dispatch({
      type: actionTypes.VERIFY_USER_FAILURE,
      payload: error.response?.data?.error || 'Failed to verify user',
    });
    //dispatch(showAlert(error.response?.data?.error || 'Failed to verify user', 'error'));
  }
};

// Assign Roles to User
export const assignUserRoles = (id, roleIds) => async (dispatch) => {
  dispatch({ type: actionTypes.ASSIGN_USER_ROLES_REQUEST });
  try {
    const response = await userService.assignRoles(id, roleIds);
    dispatch({
      type: actionTypes.ASSIGN_USER_ROLES_SUCCESS,
      payload: response.data,
    });
    //dispatch(showAlert('Roles assigned successfully', 'success'));
  } catch (error) {
    dispatch({
      type: actionTypes.ASSIGN_USER_ROLES_FAILURE,
      payload: error.response?.data?.error || 'Failed to assign roles',
    });
    //dispatch(showAlert(error.response?.data?.error || 'Failed to assign roles', 'error'));
  }
};

// Fetch User Roles
export const fetchUserRoles = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_USER_ROLES_REQUEST });
  try {
    const response = await userService.getUserRoles(id);
    dispatch({
      type: actionTypes.FETCH_USER_ROLES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_USER_ROLES_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch user roles',
    });
  }
};

// Fetch User Activity
export const fetchUserActivity = (id, params = {}) => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_USER_ACTIVITY_REQUEST });
  try {
    const response = await userService.getUserActivity(id, params);
    dispatch({
      type: actionTypes.FETCH_USER_ACTIVITY_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_USER_ACTIVITY_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch user activity',
    });
  }
};

// Fetch User Statistics
export const fetchUserStatistics = () => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_USER_STATISTICS_REQUEST });
  try {
    const response = await userService.getUserStatistics();
    dispatch({
      type: actionTypes.FETCH_USER_STATISTICS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_USER_STATISTICS_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch statistics',
    });
  }
};

// Fetch User Hierarchy
export const fetchUserHierarchy = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_USER_HIERARCHY_REQUEST });
  try {
    const response = await userService.getUserHierarchy(id);
    dispatch({
      type: actionTypes.FETCH_USER_HIERARCHY_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_USER_HIERARCHY_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch user hierarchy',
    });
  }
};

// Fetch Organization Chart
export const fetchOrganizationChart = () => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_ORGANIZATION_CHART_REQUEST });
  try {
    const response = await userService.getOrganizationChart();
    dispatch({
      type: actionTypes.FETCH_ORGANIZATION_CHART_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_ORGANIZATION_CHART_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch organization chart',
    });
  }
};

export const clearUserSuccess = () => ({ type: actionTypes.CLEAR_USER_SUCCESS });
export const clearUserError = () => ({ type: actionTypes.CLEAR_USER_ERROR });